import React, { useState, useEffect } from 'react';
import { Link, useLoaderData } from "react-router-dom";
import { useAccount } from '../assets/js/ContextProviders/AccountContext';
import { handleSubmit } from '../apis/dataService';
import DefaultImg from '../Images/Products/Default.png';
import { useLoading } from '../assets/js/ContextProviders/LoadingContext';
import axios from 'axios';
import { BackendURL } from '../utils/BackendURL';

export default function CartCard(props) {

    const { loading, startLoading, stopLoading } = useLoading();


    // CHANGE THE REMOVEBTN WITH UPDATEBTN:
    function RemoveWithUpdate(RWU, index) {
        // CHANGE THE REMOVE-BTN WITH UPDATE-BTN AND UPDATE THE QUANTITIES ON CLIENT-SIDE
        let Removebtn = document.getElementById(`Removebtn-${index}`);
        let Updatebtn = document.getElementById(`Update${index}`);
        if (RWU) {
            Updatebtn.style.display = 'flex';
            Removebtn.style.display = 'none';
        } else {
            Updatebtn.style.display = 'none';
            Removebtn.style.display = 'flex';
        }
    }

    // QUANTITY PLUS MINUS LOGIC:
    const [quantity, setquantity] = useState(props.quantity);
    function minusquantity() {
        setquantity(Math.max(0, quantity - 1));
        RemoveWithUpdate(true,props.index)
    }
    function plusquantity() {
        setquantity(quantity + 1);
        RemoveWithUpdate(true,props.index)
    }

    // DYNAMICALLY IMPORT IMAGES OF CARDS:
    const [img, setimg] = useState(null);
    useEffect(() => {
        // Dynamically import the image using the variable
        import(`../Images/Products/${props.name}.png`)
            .then((image) => setimg(image.default))
            .catch((error) => console.error('Error loading image:', error));
    }, [props.name, props.category]); // Add props.imgname and props.category to the dependency array

    // SEND UPDATE REQUEST TO BACKEND
    async function handleUpdateQuantity(ID, quantity, index) {
        startLoading()
        try {
            const jobId = ID;
            const newQuantity = quantity;

            const res = await axios.put(`${BackendURL}/jobs-cvs/${jobId}`, { Quantity: newQuantity });
            console.log(res.data);
            RemoveWithUpdate(false, index)
            props.fetchData()
            stopLoading()
        } catch (error) {
            console.error('Error:', error.message);
            stopLoading()
        }
    };



    // HANDLE REMOVE FROM CART:
    const handleRemove = async (productId) => {
        startLoading()
        try {
            // Make an HTTP DELETE request to your backend with the product ID
            const response = await axios.delete(`${BackendURL}/deletefromcart/${productId}`);
            const card = document.getElementById(`cart-card-${props.index}`)
            props.fetchData()
            stopLoading()
        } catch (error) {
            console.error('Error deleting document:', error);
            alert('Error deleting document. Please try again.');
            stopLoading()
        }
    };

    return (
        <div className="cart-card" id={`cart-card-${props.index}`} key={props.index}>
            <img src={img ? img : DefaultImg} className="product--image" alt="" />
            <h2>{props.name}</h2>
            <p className="price">Price: {props.price} -/Rs</p>
            <p>{props.description}</p>
            <div className='cart-card-btnandcontrols'>
                <div className="quantity-controls">
                    <button className="mnbtn" onClick={() => minusquantity(props.index)}>
                        -
                    </button>
                    <div className="quantity" id={`Quantityof${props.index}`}>
                        {quantity}
                    </div>
                    <button className="mnbtn" onClick={() => plusquantity(props.index)}>
                        +
                    </button>
                </div>
                <div className="cart-updatebtn" id={`Update${props.index}`} onClick={() => handleUpdateQuantity(props.productId, quantity, props.index)}>
                    UPDATE CART
                </div>
                <button className='remove-button' onClick={() => handleRemove(props.productId)} id={`Removebtn-${props.index}`}>
                    REMOVE FROM CART
                </button>
            </div>
        </div>
    );
}